'use client';

import Link from 'next/link';
import { useTrialDuration } from '@/hooks/useTrialDuration';
import LogoAnimatedGreeks from '@/components/logos/LogoAnimatedGreeks';

export default function Header() {
  const trialDays = useTrialDuration();
  return (
    <header className="sticky top-0 z-50 bg-brand-navy/95 backdrop-blur-sm border-b border-brand-blue/20">
      <nav className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link href="/" className="flex items-center space-x-3">
            <LogoAnimatedGreeks className="w-10 h-10" interval={3000} />
            <div>
              <span className="text-xl font-montserrat font-bold text-white block">
                ΘDTE <span className="text-brand-orange">Toolbox</span>
              </span>
              <span className="text-[10px] text-gray-400 block leading-tight">Real-Time Options Analytics</span>
            </div>
            {process.env.NODE_ENV === 'development' && (
              <span className="ml-4 bg-yellow-400/20 text-yellow-400 border border-yellow-400/50 px-2 py-0.5 rounded text-xs font-bold uppercase tracking-wider animate-pulse">
                Development
              </span>
            )}
          </Link>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center space-x-8">
            <Link href="/" className="text-white hover:text-brand-blue transition-colors">
              Home
            </Link>
            {/* <Link href="/services" className="text-white hover:text-brand-blue transition-colors">
              Services
            </Link> */}
            <Link href="/pricing" className="text-white hover:text-brand-blue transition-colors">
              Pricing
            </Link>
            <Link href="/blog" className="text-white hover:text-brand-blue transition-colors">
              Blog
            </Link>
            <Link href="/about" className="text-white hover:text-brand-blue transition-colors">
              About
            </Link>
            <Link href="/login" className="text-white hover:text-brand-blue transition-colors">
              Login
            </Link>
          </div>

          {/* CTA Button */}
          <Link
            href="/register"
            className="hidden md:inline-block bg-gradient-to-r from-brand-orange to-red-500 hover:from-brand-orange/90 hover:to-red-600 text-white font-bold px-6 py-2 rounded-full shadow-lg hover:shadow-brand-orange/20 transition-all duration-300 transform hover:scale-105"
          >
            Start Your {trialDays}-Day Free Trial
          </Link>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-white">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </nav>
    </header>
  );
}
